import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";

angular
  .module('bringoz.admin.working-slots')
  .factory('$workingSlots', labelsObjectFactory);

/* @ngInject */
function labelsObjectFactory($bringozFactory: $bringozFactory,
                             WorkingSlotsAPI: BringozApi,
                             WorkingSlots_DS: DataStoreConfig) {
  function $workingSlots(id: string) {
    return $bringozFactory(id, WorkingSlotsAPI, WorkingSlots_DS)
  }

  return $workingSlots;
}
